import { createApp } from 'vue'
import { createVuetify } from 'vuetify'
import { vueKeycloak } from '@josempgon/vue-keycloak'
import App from './App.vue'
import router from './router'
import i18n from "@/i18n"
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

const vuetify = createVuetify({
    theme: {
        defaultTheme: "system",
        themes: {
            light: {
                colors: {
                    'anchor-color': '#34EABC',
                },
            },
            dark: {
                colors: {
                    'anchor-color': '#6b4da9',
                },
            },
        },
    },
}

);
const app = createApp(App)
app.use(vuetify);
await vueKeycloak.install(app, {
    config: {
        url: import.meta.env.VITE_KEYCLOAK_URL,
        realm: import.meta.env.VITE_REALM_NAME,
        clientId: import.meta.env.VITE_CLIENT_ID,
    },
    initOptions: {
        onLoad: 'login-required',
        pkceMethod: 'S256'
    }
});
app.use(i18n);
app.use(router);

app.mount('#app')


